import { createContext } from 'react';

/**
 * Called when a nav row is activated, so the mobile drawer can close itself.
 *
 * A context rather than prop-drilling through three levels of nav rendering, and a
 * separate file so `react-refresh/only-export-components` never fires — the same split
 * `lib/authContext.ts` documents.
 *
 * The default is a no-op, which is what makes the DESKTOP sidebar structurally unable to
 * close anything rather than merely not asked to.
 */
export const SidebarNavigateContext = createContext<() => void>(() => undefined);
